import { useSyncUrl } from "./useSyncUrl";

export { toBoolean } from "./utils";
export default useSyncUrl;
